import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../shared/api-response.model';
import {CmsEventParticipantLinkContainerModel } from '../../../../../../models/aggregates/cms/event-calendar';
import { ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';

@Injectable({providedIn: 'root'})

export class CmsCalendarEventParticipantService extends BaseApiTemplateService<CmsEventParticipantLinkContainerModel> {
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-event-participant-links/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-event-participant-links/backoffice-ep';
        this.httpClient = http;
      }

      postMultiple(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<CmsEventParticipantLinkContainerModel>> {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-event-participant-links/multiple/backoffice-ep';
        }
        return this.httpClient.post<ApiResponseModel<CmsEventParticipantLinkContainerModel>>(
          this.apiUrl,
          dtoObject,
          this.getHttpHeader(visa)
        );
      }
}